import {
  FETCH_LEADER_ALERTS,
  FETCH_LEADER_ALERTS_SUCCESS,
  FETCH_LEADER_ALERTS_FAILED,
  EDIT_LEADER_ALERT,
  FETCH_LEADER_WEEKLY_HISTORY,
  FETCH_LEADER_WEEKLY_HISTORY_SUCCESS,
  FETCH_LEADER_WEEKLY_HISTORY_FAILED,
} from '../store/types';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, update, get } from 'firebase/database';

export const fetchLeaderAlerts = () => (dispatch) => {
  const { leaderAlertsRef } = firebase;
  dispatch({ type: FETCH_LEADER_ALERTS, payload: null });
  onValue(
    leaderAlertsRef,
    (snapshot) => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data).map((i) => ({ ...data[i], id: i }));
        arr.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
        dispatch({ type: FETCH_LEADER_ALERTS_SUCCESS, payload: arr });
      } else {
        dispatch({ type: FETCH_LEADER_ALERTS_SUCCESS, payload: [] });
      }
    },
    (err) => {
      dispatch({
        type: FETCH_LEADER_ALERTS_FAILED,
        payload: err?.message || 'leader_alerts_fetch_failed',
      });
    }
  );
};

export const editLeaderAlert = (alert, method) => async (dispatch) => {
  const { leaderAlertEditRef } = firebase;
  dispatch({ type: EDIT_LEADER_ALERT, payload: { method, alert } });
  if (method === 'Update' && alert?.id) {
    const { id, ...rest } = alert;
    await update(leaderAlertEditRef(id), {
      ...rest,
      updatedAt: Date.now(),
    });
  }
};

/** Historial semanal de todos los líderes */
export const fetchLeaderWeeklyHistory = (opts = {}) => (dispatch, getState) => {
  const existing = getState()?.leaderAlerts?.history;
  if (!opts.force && existing && existing.length > 0) {
    return;
  }
  const { leaderWeeklyHistoryRef } = firebase;
  dispatch({ type: FETCH_LEADER_WEEKLY_HISTORY, payload: null });
  onValue(
    leaderWeeklyHistoryRef,
    (snapshot) => {
      const root = snapshot.val() || {};
      const rows = [];
      Object.keys(root).forEach((uid) => {
        const weeks = root[uid] || {};
        Object.keys(weeks).forEach((weekKey) => {
          const w = weeks[weekKey] || {};
          rows.push({
            id: `${uid}_${weekKey}`,
            leaderUid: uid,
            weekKey,
            drivers: Number(w.drivers) || 0,
            customers: Number(w.customers) || 0,
            updatedAt: w.updatedAt || null,
          });
        });
      });
      rows.sort((a, b) => {
        if (a.weekKey === b.weekKey) return (b.updatedAt || 0) - (a.updatedAt || 0);
        return String(b.weekKey).localeCompare(String(a.weekKey));
      });
      dispatch({ type: FETCH_LEADER_WEEKLY_HISTORY_SUCCESS, payload: rows });
    },
    (err) => {
      dispatch({
        type: FETCH_LEADER_WEEKLY_HISTORY_FAILED,
        payload: err?.message || 'leader_weekly_history_failed',
      });
    },
    { onlyOnce: true }
  );
};

/** Historial de cambios de líder (más reciente primero) */
export const fetchLeaderChanges = async () => {
  const { leaderChangesRef } = firebase;
  const snapshot = await get(leaderChangesRef);
  const data = snapshot.val() || {};
  return Object.keys(data)
    .map((id) => ({ ...data[id], id }))
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
};

/** Reemplaza un líder por otro conductor (por correo). Solo admin. */
export const replaceNetworkLeader = async ({ oldLeaderUid, newLeaderEmail, reason }) => {
  const { auth, config } = firebase;
  const settings = store.getState().settingsdata.settings;
  const host =
    window && window.location && settings.CompanyWebsite === window.location.origin
      ? window.location.origin
      : `https://${config.projectId}.web.app`;
  try {
    const idToken = await auth.currentUser.getIdToken();
    const response = await fetch(`${host}/replace_network_leader`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ oldLeaderUid, newLeaderEmail, reason }),
    });
    const result = await response.json();
    if (result.success) return result;
    return { success: false, error: result.error || 'No se pudo completar el cambio de líder.' };
  } catch (error) {
    return { success: false, error: error?.message || 'No se pudo completar el cambio de líder.' };
  }
};
